import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-ag-grid-options',
	templateUrl:'./AgGridOptionsPluginCompPage.html',
	styles: [],
	styleUrls:['./AgGridOptionsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class AgGridOptionsPluginCompPage
{
	mdContent_729 = `\`\`\`java
import com.jwebmp.plugins.aggrid.AgGridOptions;
\`\`\``;
	mdContent_730 = `\`\`\`java
AgGridOptions()
\`\`\``;
	mdContent_731 = `\`\`\`java
AgGridOptions&lt;?&gt; options = new AgGridOptions&lt;&gt;();
options.configureRendering()
    .setAnimateRows(true)
    .setCellFlashDuration(500);
options.configurePagination()
    .setPagination(true)
    .setPaginationPageSize(50);
options.configureEditing()
    .setSingleClickEdit(true)
    .setStopEditingWhenCellsLoseFocus(true);
\`\`\``;
	mdContent_732 = `\`\`\`java
AgGridOptions&lt;?&gt; options = new AgGridOptions&lt;&gt;();
options.configureSelection()
    .setRowSelection(RowSelectionMode.multiRow)
    .setRowMultiSelectWithClick(true);
options.configureFiltering()
    .setQuickFilterText("search term")
    .setFloatingFilter(true);
\`\`\``;
	mdContent_733 = `\`\`\`java
AgGridOptions&lt;?&gt; options = new AgGridOptions&lt;&gt;();
options.configureRowGrouping()
    .setRowGroupPanelShow("always")
    .setGroupDisplayType("multipleColumns");
options.configureRowPivoting()
    .setPivotMode(true)
    .setPivotPanelShow("always");
\`\`\``;
	mdContent_734 = `\`\`\`java
AgGridOptions&lt;?&gt; options = new AgGridOptions&lt;&gt;();
options.configureServerSideRowModel()
    .setServerSideDatasource("myDatasource")
    .setCacheBlockSize(100)
    .setMaxBlocksInCache(10);
\`\`\``;
	mdContent_735 = `\`\`\`java
AgGridOptions&lt;?&gt; options = new AgGridOptions&lt;&gt;();
options.setTreeData(true);
options.setGetDataPathRaw("(data) =&gt; data.path");
\`\`\``;
	mdContent_736 = `\`\`\`java
AgGridOptions&lt;?&gt; options = new AgGridOptions&lt;&gt;();
options.configureExport()
    .setSuppressExcelExport(false)
    .setSuppressCsvExport(false)
    .setColumnSeparator(";");
\`\`\``;
}
